import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import SearchPaging from "./../factories/search-paging";
function DepartmentViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Department())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
}
Bao.inherit(DepartmentViewModel, SearchPaging);
DepartmentViewModel.prototype.PrimaryKey = "DepartmentId";
DepartmentViewModel.prototype.RefreshUrl = "Department/GetDepartment";
DepartmentViewModel.prototype.SaveUrl = "Department/SaveDepartment";
DepartmentViewModel.prototype.DeleteUrl = "Department/DeleteDepartment";
DepartmentViewModel.prototype.IsInUseUrl = "Department/IsDepartmentInUse";
DepartmentViewModel.prototype.PermissionForward = "DepartmentMoveForwardSearch";
DepartmentViewModel.prototype.PermissionBackward = "DepartmentMoveBackwardSearch";
DepartmentViewModel.prototype.PermissionSave = "DepartmentSave";
DepartmentViewModel.prototype.PermissionRefresh = "DepartmentRefresh";
DepartmentViewModel.prototype.PermissionDelete = "DepartmentDelete";
export default DepartmentViewModel;